<template>
  <div class="not-found-page" style="min-height: 90vh;">
    <Hero image="homeBanner.jpg" layout="lg" title=""/>

    <div class="row pb-5 mt-n5">
      <div class="col-12 col-lg-10 mx-auto">
        <div class="bg-white shadow-sm">

          <div class="row">
            <div class="col-10 mx-auto my-5">

              <h1>Página não encontrada :(</h1>

            </div>
          </div>

        </div>
      </div>
    </div>

  </div>
</template>

<script>
  import Hero from "@/components/media/Hero.vue";
  export default {
    name: 'NotFound',

    components: {
      Hero
    }
  }
</script>

<style lang="scss" scoped>
</style>